<div>
  <div class="content-blue" [class.m-2-5]="!lineBool" [class.annotationWithinContent]="isParaNum" [class.annotationContentBoolWithoutNum]="!isParaNum" *ngFor="let annotation of annotationContent">
    <div *ngIf="lineBool">
      <hr />
    </div>
    <div class="annotation-content-title">
      {{annotation.annotationTitle}}
    </div>
    <div class="my-0-25 flex-display">
      <div class="flex-display mb-0-25">
        <span class="sub-title-label">
          <strong>{{addedTextLabel}}</strong>:&nbsp;
        </span>
        &nbsp;
        <span class="sub-content">
          {{annotation.createdOn.split(" ")[0]}}
        </span>
      </div>
    </div>
    <div class="sub-content-description my-1">
      {{annotation.annotationDescription}}
    </div>
    <div class="annotation-actions flex-display justify-content-space-between print-content-hide">
      <div class="flex-display font-14">
        <div class=" cursor-pointer position-relative" tabindex="0" (click)="editAnnotation(annotation)" (keyup.enter)="editAnnotation(annotation)">
          <img src="../../../assets/icons/pencil.svg" class="icon-image-para-action" alt="Edit"> &nbsp; <span class="border-bottom-1 highlight-blue ml-1">{{editLinkLabel}}</span> &nbsp;&nbsp;
        </div>
        <div class="cursor-pointer ml-1 position-relative" tabindex="0" (click)="copyToClipboard(annotation)" (keyup.enter)="copyToClipboard(annotation)">
          <img src="../../../assets/icons/share-icon.svg" class="icon-image-para-action" alt="Share"> &nbsp; <span class="border-bottom-1 highlight-blue ml-1">{{shareLinkLabel}}</span>
        </div>
      </div>
      <div class=" cursor-pointer position-relative" tabindex="0" (click)="deleteAnnotation(annotation)" (keyup.enter)="deleteAnnotation(annotation)">
        <img src="../../../assets/icons/trash-red.svg" class="icon-image-para-action" alt="Delete"> &nbsp; <span class="border-bottom-1 highlight-blue ml-1">{{deleteLinkLabel}}</span>
      </div>

    </div>
  </div>
</div>
